document.addEventListener('DOMContentLoaded', function () {
  const interval = setInterval(() => {
    const element = document.querySelector('.yotpo-star-rating.yotpo-bottom-line-stars'); // phần tử muốn di chuyển
    const newParent = document.querySelector('.ratings-custom-header'); // nơi muốn đưa vào
    const btn = document.getElementById('yotpo-main-widget-btn');

    if (element && newParent && btn) {
      newParent.appendChild(element);
      btn.textContent = 'Write your review';
      clearInterval(interval);
    }
  }, 500);
});
